import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import PriceLabel from '@prisjakt/ui-price-label';

type ShippingLabelProps = {
  compact?: boolean;
};

export const ShippingLabel = styled(PriceLabel)<ShippingLabelProps>(
  props => css`
    ${props.compact &&
      css`
        font-size: ${layout.measurements.fontSizeSmall};
      `}
  `
);
